<template>
	<div class="box">
		<div class="header">
			<div class="header-text">{{trainName}}</div>
			<div class="header-time">{{trainTime}}</div>
		</div>
		<div class="complete" v-show="record==0">
			<img src="../assets/images/complete.png" alt="">
			<div class="complete-info">
				<div class="complete-title">恭喜完成！</div>
				<div class="complete-num">这是您完成的第<span>{{trainNum}}</span>次训练</div>
			</div>
		</div>
		<!--        <div class="day-chart" v-if="trainName!=''&&trainName!='自由练习'">
            <div class="empty" v-show="hourData.length==0">
                <img src="../assets/images/no-data.png" alt="">
                <div class="empty-text">暂无数据</div>
            </div>
            <div class="chart-content" v-show="hourData.length>0">
                <div class="chart-main">
                    <div class="text-tag">
                        <div class="text-tag-aa">压力较大</div>
                        <div class="text-tag-bb">稍有压力</div>
                        <div class="text-tag-cc">放松</div>
                    </div>
                    <div class="chart-day">
                        <div class="chart-day-main">
                            <div :class="item.time_str>=trainStart&&item.time_str<=trainEnd ? 'bar-box-ac':'bar-box'"
                                v-for="item in hourData" :key="item.time_str" :style="{left:leftFilter(item.time_str)}">
                                <div class="train-point" v-if="item.time_str>=trainStart&&item.time_str<=trainEnd">训练
                                </div>
                                <div class="bar"
                                    :style="{backgroundColor:colorFilter(item.stress_index),height:2*item.stress_index+'px'}">
                                </div>
                            </div>
                        </div>
                        <div class="point-line-a"></div>
                        <div class="point-line-b"></div>
                        <div class="mean-line" :style="{bottom:hourMean*2+'px',borderColor:colorFilter(hourMean)}"
                            v-show="hourData.length!=0"></div>
                        <div class="mean-point"
                            :style="{bottom:hourMean*2-10+'px',backgroundColor:colorFilter(hourMean)}"
                            v-show="hourData.length!=0">平均{{hourMean}}</div>
                        <div>
                            <div class="line-d"></div>
                            <div class="line-e"></div>
                            <div class="line-f"></div>
                            <div class="line-dd"></div>
                            <div class="line-ee"></div>
                            <div class="line-ff"></div>
                        </div>
                        <div class="time-list-box">
                            <div class="day-time-list">
                                <div class="day-time-item" v-for="(item,index) in timeList" :key="index">{{item}}</div>
                            </div>
                            <div class="minute-point">分</div>
                        </div>
                    </div>
                    <div class="num-tag">
                        <div class="num-tag-a">100</div>
                        <div class="num-tag-b">70</div>
                        <div class="num-tag-c">50</div>
                    </div>
                </div>
            </div>
        </div> -->



		<div class="day-chart">
			<div class="empty" v-show="hourData.length==0">
				<img src="../assets/images/no-data.png" alt="">
				<div class="empty-text">暂无数据</div>
			</div>
			<div class="chart-content" v-show="hourData.length>0">
				<div class="chart-main">
					<div class="text-tag" style="height:300px;">
						<div class="text-tag-aaa" style="color:#FF0036;" v-if="selectChart!=1">{{barEmoStr[0]||''}}
						</div>
						<div class="text-tag-aaa" style="color:#55CF04;" v-else>{{barEmoStr[0]||''}}</div>
						<div class="text-tag-bbb">{{barEmoStr[1]||''}}</div>
						<div class="text-tag-ccc" style="color:#55CF04;" v-if="selectChart!=1">{{barEmoStr[2]||''}}
						</div>
						<div class="text-tag-ccc" style="color:#FF0036;" v-else>{{barEmoStr[2]||''}}</div>
					</div>
					<div class="chart-day" style="width:300px;height: 300px;">
						<div class="chart-day-main" style="width:300px;height: 300px;">
							<div class="index-type">
								<div class="choice-index" @click="showIndex = true">{{indexText}}</div>
								<img src="../assets/images/open-list.png" alt="" @click="showIndex = true"
									class="index-more">
								<div class="index-list" v-show="showIndex">
									<div class="index-item" @click="changeChartStress(0)">压力指数</div>
									<div class="index-item" @click="changeChartStress(1)">心情指数</div>
									<div class="index-item" @click="changeChartStress(2)">疲劳指数</div>
								</div>
							</div>
							<div id="chartBar" style="width:300px;height:300px;"></div>
						</div>
					</div>
					<div class="num-tag"></div>
				</div>
			</div>
		</div>


		<div class="day-chart">
			<div class="empty" v-show="hourData.length==0">
				<img src="../assets/images/no-data.png" alt="">
				<div class="empty-text">暂无数据</div>
			</div>
			<div class="chart-content" v-show="hourData.length>0">
				<div class="chart-main">
					<div class="text-tag" style="height:300px;">
						<div class="text-tag-aaa" style="color:#FF0036;" v-if="selectChartLine!=1">{{lineEmoStr[0]||''}}
						</div>
						<div class="text-tag-aaa" style="color:#55CF04;" v-else>{{lineEmoStr[0]||''}}</div>
						<div class="text-tag-bbb">{{lineEmoStr[1]||''}}</div>
						<div class="text-tag-ccc" style="color:#55CF04;" v-if="selectChartLine!=1">{{lineEmoStr[2]||''}}
						</div>
						<div class="text-tag-ccc" style="color:#FF0036;" v-else>{{lineEmoStr[2]||''}}</div>
					</div>
					<div class="chart-day" style="width:300px;height: 300px;">
						<div class="chart-day-main" style="width:300px;height: 300px;">
							<div class="index-type">
								<div class="choice-index" @click="showIndex1 = true">{{indexText1}}</div>
								<img src="../assets/images/open-list.png" alt="" @click="showIndex1 = true"
									class="index-more">
								<div class="index-list" v-show="showIndex1">
									<div class="index-item" @click="changeChartTired(0)">压力指数</div>
									<div class="index-item" @click="changeChartTired(1)">心情指数</div>
									<div class="index-item" @click="changeChartTired(2)">疲劳指数</div>
								</div>
							</div>
							<div id="chartLine" style="width:300px;height:300px;"></div>
						</div>
					</div>
					<div class="num-tag"></div>
				</div>
			</div>
		</div>

		<!--        <div class="train-info" v-if="trainName!=''&&trainName!='自由练习'" v-show="hourData.length>0">
            <div class="train-time">
                <div class="train-title">本次训练时长</div>
                <div class="train-time-num">
                    <div class="time-min">{{trainMin}}</div>
                    <div class="min-text">分</div>
                    <div class="time-sec">{{trainSec}}</div>
                    <div class="sec-text">秒</div>
                </div>
            </div>
            <div class="lower">
                <div class="lower-title">压力<span v-if="preMean<nextMean">上升</span><span
                        v-if="preMean>=nextMean">降低</span></div>
                <div class="lower-identifying" v-if="nextMean==''||!nextMean">计算中…</div>
                <div class="lower-point" v-if="nextMean==''||!nextMean">请30分钟后查看结果</div>
                <div class="contrast-index" v-if="nextMean!=''&&nextMean">
                    <div class="contrast-num">{{contrast}}</div>
                    <div class="contrast-text">%</div>
                </div>
            </div>
        </div>
        <div class="contrast-stress" v-if="trainName!=''&&trainName!='自由练习'" v-show="hourData.length>0">
            <div class="train-pre">
                <div class="pre-title">压力指数：练习前</div>
                <div class="pre-index">
                    <div class="pre-num">{{preMean}}</div>
                    <div class="pre-text" :style="{color:colorFilter(preMean)}">{{formatStress(preMean)}}</div>
                </div>
            </div>
            <div class="mid-icn"></div>
            <div class="train-next">
                <div class="lower-title">压力指数：练习后</div>
                <div class="lower-identifying" v-if="nextMean==''||!nextMean">计算中…</div>
                <div class="lower-point" v-if="nextMean==''||!nextMean">请30分钟后查看结果</div>
                <div class="pre-index" v-if="nextMean!=''&&nextMean">
                    <div class="pre-num">{{nextMean}}</div>
                    <div class="pre-text" :style="{color:colorFilter(nextMean)}">{{formatStress(nextMean)}}</div>
                </div>
            </div>
        </div> -->


		<!-- 自由练习 -->
		<div class="train-info" v-show="hourData.length>0">
			<div class="train-time">
				<div class="train-title">本次训练时长</div>
				<div class="train-time-num">
					<div class="time-min">{{trainMin}}</div>
					<div class="min-text">分</div>
					<div class="time-sec">{{trainSec}}</div>
					<div class="sec-text">秒</div>
				</div>
			</div>
			<div class="lower">
				<div class="lower-title">{{emoChangeStr[emoChangeStrindex]}}<span
						v-if="preMeanChange<nextMeanChange">上升</span><span
						v-if="preMeanChange>=nextMeanChange">降低</span></div>
				<div class="lower-identifying" v-if="nextMeanChange==''||!nextMeanChange">{{undata?"未检测到数据":"计算中…"}}</div>
				<div class="lower-point" v-if="nextMeanChange==''||!nextMeanChange">{{undata?"":"请30分钟后查看结果"}}</div>
				<div class="contrast-index" v-if="nextMeanChange!=''&&nextMeanChange">
					<div class="contrast-num">{{contrastChange}}</div>
					<div class="contrast-text">%</div>
				</div>
			</div>
		</div>
		<div class="contrast-stress" v-show="hourData.length>0">
			<div class="train-pre">
				<div class="pre-title">{{emoChangeStr[emoChangeStrindex]}}指数：练习前</div>
				<div class="pre-index">
					<div class="pre-num">{{preMeanChange}}</div>
					<div class="pre-text" :style="{color:colorFilter(preMeanChange)}">{{formatEmo(preMeanChange)}}
					</div>
				</div>
			</div>
			<div class="mid-icn"></div>
			<div class="train-next">
				<div class="lower-title">{{emoChangeStr[emoChangeStrindex]}}指数：练习后</div>
				<div class="lower-identifying" v-if="nextMeanChange==''||!nextMeanChange">{{undata?"未检测到数据":"计算中…"}}</div>
				<div class="lower-point" v-if="nextMeanChange==''||!nextMeanChange">{{undata?"":"请30分钟后查看结果"}}</div>
				<div class="pre-index" v-if="nextMeanChange!=''&&nextMeanChange">
					<div class="pre-num">{{nextMeanChange}}</div>
					<div class="pre-text" :style="{color:colorFilter(nextMeanChange)}">{{formatEmo(nextMeanChange)}}
					</div>
				</div>
			</div>
		</div>
		<div class="back" @click="back">返回</div>
	</div>
</template>
<script>
	import moment from 'moment'
	import {
		describe
	} from '../api/emotion'
	import {
		train_report,
		train_ln,
		train_info
	} from '../api/server'
	export default {
		data() {
			return {
				undata:false,
				indexText: '压力指数',
				showIndex: false,
				indexText1: '压力指数',
				showIndex1: false,
				emoChangeStr: ['压力', '心情', '疲劳'],
				emoChangeStrindex: [0],
				barEmoStr: ['压力较大', '稍有压力', '放松'],
				lineEmoStr: ['压力较大', '稍有压力', '放松'],
				selectChart: 0,
				selectChartLine: 0,
				chartTypebLine: [{
					text: "压力趋势",
					value: 0
				}, {
					text: "心情趋势",
					value: 1
				}, {
					text: "疲劳趋势",
					value: 2
				}],
				imei: '',
				hourData: [],
				recently_data: {},
				startTime: 0,
				endTime: 0,
				indicators_data: [],
				nowHour: '',
				hourMean: 0,
				timeList: [],
				trainTime: '',
				trainStart: '',
				trainEnd: '',
				preMean: '',
				preMeanChange: '',
				nextMeanChange: '',
				nextMean: '',
				contrast: '',
				contrastChange: '',
				tiredcontrast: '',
				emotioncontrast: '',
				trainMin: '',
				trainSec: '',
				trainNum: '',
				trainName: '',
				record: 0,
				Mdata: [],
				stressData: [],
				tiredData: [],
				emotionData: [],
				lineChart: null,
				barChart: null,
				markarea: []
			};
		},
		computed: {

		},
		methods: {
			checkIndex() {
				console.log("checkIndex");
			},
			changeChartTired(i) {
				console.log("this.Mdata");
				console.log(this.Mdata);
				this.indexText1 = this.emoChangeStr[i] + '指数';
				this.showIndex1 = false;
				this.emoChangeStrindex = i;
				this.selectChartLine = i;
				let darr = [this.stressData, this.emotionData, this.tiredData]
				let data = darr[i]
				console.log(data);
				if (i == 0) {
					this.contrastChange = this.contrast;
					this.nextMeanChange = this.nextMean;
					this.preMeanChange = this.preMean;
					// contrastChange
					this.lineEmoStr = ['压力较大', '稍有压力', '放松'];
					let initdata = []
					for (let i in this.Mdata) {
						if (data[i]) {
							let colorStr = '#FF0036'
							if (data[i].stress_index >= 50 && data[i].stress_index < 70) {
								colorStr = '#01D6D6'
							}
							if (data[i].stress_index >= 70) {
								colorStr = '#55CF04'
							}
							initdata.push({
								value: data[i].stress_index,
								itemStyle: {
									color: colorStr
								}
							})
						} else {
							initdata.push(null)
						}
					}
					this.initLineChart(initdata)
				}
				if (i == 1) {
					this.contrastChange = this.emotioncontrast;
					this.nextMeanChange = this.emotionnextMean;
					this.preMeanChange = this.emotionpreMean;
					this.lineEmoStr = ['状态良好', '状态一般', '较差'];
					let initdata = []
					for (let i in this.Mdata) {
						if (data[i]) {
							let colorStr = '#FF0036'
							if (data[i].emotion_index >= 50 && data[i].emotion_index < 70) {
								colorStr = '#01D6D6'
							}
							if (data[i].emotion_index >= 70) {
								colorStr = '#55CF04'
							}
							initdata.push({
								value: data[i].emotion_index,
								itemStyle: {
									color: colorStr
								}
							})
						} else {
							initdata.push(null)
						}
					}
					this.initLineChart(initdata)
				}
				if (i == 2) {
					this.contrastChange = this.tiredcontrast;
					this.nextMeanChange = this.tirednextMean
					this.preMeanChange = this.tiredpreMean;
					let initdata = []
					this.lineEmoStr = ['十分疲惫', '有点疲惫', '放松'];
					for (let i in this.Mdata) {
						if (data[i]) {
							let colorStr = '#55CF04'
							if (data[i].tired_index >= 50 && data[i].tired_index < 70) {
								colorStr = '#01D6D6'
							}
							if (data[i].tired_index >= 70) {
								colorStr = '#FF0036'
							}
							initdata.push({
								value: data[i].tired_index,
								itemStyle: {
									color: colorStr
								}
							})
						} else {
							initdata.push(null)
						}
					}
					this.initLineChart(initdata)
				}
			},
			changeChartStress(i) {
				this.selectChart = i;
				this.indexText = this.emoChangeStr[i] + '指数';
				this.showIndex = false;
				this.emoChangeStrindex = i;
				let darr = [this.stressData, this.emotionData, this.tiredData]
				// let dindex = ['stress_index','emotion_index','tired_index']
				let data = darr[i]
				// let data = this.emotionData;
				console.log("-------data");
				console.log(data[i])
				if (i == 0) {
					this.contrastChange = this.contrast
					this.nextMeanChange = this.nextMean;
					this.preMeanChange = this.preMean;
					// this.tirednextMean =
					this.barEmoStr = ['压力较大', '稍有压力', '放松'];
					let initdata = []
					for (let i in this.Mdata) {
						if (data[i]) {
							let colorStr = '#55CF04'
							if (data[i].stress_index >= 50 && data[i].stress_index < 70) {
								colorStr = '#01D6D6'
							}
							if (data[i].stress_index >= 70) {
								colorStr = '#FF0036'
							}
							initdata.push({
								value: data[i].stress_index,
								itemStyle: {
									color: colorStr
								}
							})
						} else {
							initdata.push(null)
						}
					}
					this.initBarChart(initdata)
				}
				if (i == 1) {
					this.contrastChange = this.emotioncontrast;
					this.nextMeanChange = this.emotionnextMean;
					this.preMeanChange = this.emotionpreMean;
					this.barEmoStr = ['状态良好', '状态一般', '较差'];
					let initdata = []
					for (let i in this.Mdata) {
						if (data[i]) {
							let colorStr = '#FF0036'
							if (data[i].emotion_index >= 50 && data[i].emotion_index < 70) {
								colorStr = '#01D6D6'
							}
							if (data[i].emotion_index >= 70) {
								colorStr = '#55CF04'
							}
							initdata.push({
								value: data[i].emotion_index,
								itemStyle: {
									color: colorStr
								}
							})
						} else {
							initdata.push(null)
						}
					}
					this.initBarChart(initdata)
				}
				if (i == 2) {
					this.contrastChange = this.tiredcontrast;
					this.nextMeanChange = this.tirednextMean
					this.preMeanChange = this.tiredpreMean;
					this.barEmoStr = ['十分疲惫', '有点疲惫', '放松'];
					let initdata = []
					for (let i in this.Mdata) {
						if (data[i]) {
							let colorStr = '#55CF04'
							if (data[i].tired_index >= 50 && data[i].tired_index < 70) {
								colorStr = '#01D6D6'
							}
							if (data[i].tired_index >= 70) {
								colorStr = '#FF0036'
							}
							initdata.push({
								value: data[i].tired_index,
								itemStyle: {
									color: colorStr
								}
							})
						} else {
							initdata.push(null)
						}
					}
					this.initBarChart(initdata)
				}
				console.log("this.nextMeanChange");
				console.log(this.nextMeanChange);
			},
			formatStress(num) {
				let stress = ''
				for (let i = 0; i < this.indicators_data.length; i++) {
					let item = this.indicators_data[i]
					if (item.dimension == 'stress') {
						if (num >= item.min && num <= item.max) {
							stress = item.short_content
						}
					}
				}
				console.log(stress);
				console.log(this.indicators_data);
				return stress
			},
			formatEmo(num) {
				if (this.emoChangeStrindex == 0) {
					if (num <= 49) {
						return '放松'
					}
					if (num >= 50 && num <= 69) {
						return '稍有压力'
					}
					if (num >= 70 && num <= 100) {
						return '压力较大'
					}
				}
				if (this.emoChangeStrindex == 1) {
					if (num <= 49) {
						return '较差'
					}
					if (num >= 50 && num <= 69) {
						return '状态一般'
					}
					if (num >= 70 && num <= 100) {
						return '状态良好'
					}
				}
				if (this.emoChangeStrindex == 2) {
					if (num <= 49) {
						return '精力充沛'
					}
					if (num >= 50 && num <= 69) {
						return '有点疲惫'
					}
					if (num >= 70 && num <= 100) {
						return '十分疲惫'
					}
				}
			},
			describeAll() {
				describe().then(res => {
					if (res.status == 200) {
						this.indicators_data = res.data.indicators
					} else {
						this.$toast('暂无数据');
					}
				})
			},
			colorFilter(num) {
				if (this.emoChangeStrindex == 1) {
					if (num <= 49) {
						return '#FF0036'
					}
					if (num >= 50 && num <= 69) {
						return '#01D6D6'
					}
					if (num >= 70 && num <= 100) {
						return '#55CF04'
					}
				}
				if (num <= 49) {
					return '#55CF04'
				}
				if (num >= 50 && num <= 69) {
					return '#01D6D6'
				}
				if (num >= 70 && num <= 100) {
					return '#FF0036'
				}

			},
			leftFilter(time) {
				return (time - this.startTime) / 3600 * 240 - 7 + 'px'
			},
			timeListFilter(start) {
				let date = new Date(start * 1000)
				let startMin = date.getMinutes()
				let timeList = [];
				if (startMin < 10) {
					timeList.push('0' + startMin)
				} else {
					timeList.push(startMin)
				}
				for (let i = 0; i < 12; i++) {
					startMin = startMin + 5;
					if (startMin > 60) {
						startMin = startMin - 60
					}
					if (startMin < 10) {
						timeList.push('0' + startMin)
					} else {
						timeList.push(startMin)
					}
				}
				this.timeList = timeList

				console.log("tilelist");
				console.log(this.timeList);
			},
			back() {
				this.$router.push('/')
			},
			initLineChart(odata) {
				console.log("---odata");
				console.log(odata);
				let data = []
				let Mdata = []
				for(let i=0;i<12;i++){
					Mdata.push(i)
					if(odata[i]){
						data.push(odata[i])
					}else{
						data.push({})
					}
				}
				let dom = document.getElementById('chartLine');
				this.lineChart = this.$echarts.init(dom);
				let markdata = [
						[{
								itemStyle: {
									color: 'rgba(170, 255, 255, 0.4)'
								},
								name: '练习前',
								xAxis: 0
							},
							{
								xAxis: 5
							}
						],
						[{
								itemStyle: {
									color: 'rgba(170, 255, 255, 0.8)'
								},
								name: '练习后',
								xAxis: 5
							},
							{
								xAxis:  11
							}
						]
					];
				let option = {
					xAxis: {
						type: 'category',
						data: Mdata
					},
					yAxis: {
						type: 'value',
						position: 'right',
						max: 100,
						min: 0,
					},
					series: [{
						data: data,
						type: 'line',
						markArea: {
							itemStyle: {
								color: 'rgba(2, 173, 177, 0.4)'
							},
							data: markdata
						},
						symbol: 'emptyCircle',
						lineStyle: {
							color: '#ccc',
							width: 1,
							type: 'solid'
						},
					}]

				};
				this.lineChart.setOption(option);
			},
			initBarChart(odata) {
				let data = []
				let Mdata = []
				for(let i=0;i<12;i++){
					Mdata.push(i)
					if(odata[i]){
						data.push(odata[i])
					}else{
						data.push({})
					}
				}
				let dom = document.getElementById('chartBar');
				this.barChart = this.$echarts.init(dom);
				let markdata = [
						[{
								itemStyle: {
									color: 'rgba(170, 255, 255, 0.4)'
								},
								name: '练习前',
								xAxis: 0
							},
							{
								xAxis: 5
							}
						],
						[{
								itemStyle: {
									color: 'rgba(170, 255, 255, 0.8)'
								},
								name: '练习后',
								xAxis: 5
							},
							{
								xAxis:  11
							}
						]
					]
				let option = {
					xAxis: {
						type: 'category',
						data: Mdata

					},
					yAxis: {
						max: 100,
						min: 0,
						type: 'value',
						position: 'right'
					},
					series: [{
						data: data,
						type: 'bar',
						markArea: {
							data:markdata
						},
					}]
				};
				this.barChart.setOption(option);
			}
		},
		created() {
			let phone = localStorage.getItem('phone');
			train_ln(phone).then(res => {
				if (res.status == 200) {
					this.trainNum = res.data.train_num
				}
			})
			this.describeAll()
			if (this.$route.query.record) {
				this.record = 1
			}
			train_info(this.$route.query.id).then(res => {

				if (res.status == 200) {
					let trainData = res.data.trainData[0]
					this.trainName = trainData.name;
					//训练时间
					let date = new Date(trainData.end_time * 1000)
					let year = date.getFullYear();
					let month = date.getMonth() + 1;
					let day = date.getDate();
					let hour = date.getHours();
					let minutes = date.getMinutes();
					if (month < 10) {
						month = '0' + month
					}
					if (day < 10) {
						day = '0' + day
					}
					if (hour < 10) {
						hour = '0' + hour
					}
					if (minutes < 10) {
						minutes = '0' + minutes
					}
					this.trainTime = `${year}年${month}月${day}日 ${hour}:${minutes}`
					this.trainStart = trainData.start_time;
					this.trainEnd = trainData.end_time;
					this.trainMin = parseInt((this.trainEnd - this.trainStart) / 60)
					this.trainSec = parseInt((this.trainEnd - this.trainStart) % 60)
					train_report(trainData.imei, trainData.start_time, trainData.end_time,this.trainName).then(res => {
						if (res.status == 200) {
							this.hourData = res.data.stressData
							this.stressData = res.data.stressData
							this.tiredData = res.data.tiredData
							this.emotionData = res.data.emotionData
							this.startTime = res.data.startTime
							this.endTime = res.data.endTime
							this.timeListFilter(this.startTime)
							//此时段均值              
							let hourAll = 0
							let ln = 0
							let preAll = 0
							let preLn = 0
							let nextAll = 0
							let nextLn = 0
							res.data.stressData.forEach((item,index) => {
								this.Mdata.push(index)
								if(item){
									hourAll += item.stress_index
									ln+=1;
									if (item.time_str < this.trainStart) {
										preAll += item.stress_index;
										preLn += 1;
									}
									if (item.time_str >= this.trainEnd) {
										nextAll += item.stress_index;
										nextLn += 1;
									}
								}
								
							})
							this.hourMean = parseInt(hourAll / ln)
							let preMean = parseInt(preAll / preLn)
							let nextMean = parseInt(nextAll / nextLn)
							this.preMean = preMean
							this.nextMean = nextMean
							this.preMeanChange = preMean
							this.nextMeanChange = nextMean
							// 训练前后对比
							let difEnd = null
							if (nextMean >= preMean) {
								let dif = (nextMean / preMean - 1) * 100
								difEnd = dif.toFixed(0)
							}
							if (nextMean < preMean) {
								let dif = (1 - nextMean / preMean) * 100
								difEnd = dif.toFixed(0)
							}
							this.contrast = difEnd
							this.contrastChange = difEnd

							//此时段疲劳均值        tiredData      
							let tiredhourAll = 0
							let tiredln =  0
							//训练前均值
							let tiredpreAll = 0
							let tiredpreLn = 0
							let tirednextAll = 0
							let tirednextLn = 0
							res.data.tiredData.forEach(item => {
								if(item){
									tiredhourAll += item.tired_index
									tiredln+=1
									if (item.time_str < this.trainStart) {
										tiredpreAll += item.tired_index;
										tiredpreLn += 1;
									}
									if (item.time_str >= this.trainEnd) {
										tirednextAll += item.tired_index;
										tirednextLn += 1;
									}
								}
							})
							this.tiredhourMean = parseInt(tiredhourAll / tiredln)
							let tiredpreMean = parseInt(tiredpreAll / tiredpreLn)
							console.log("tiredpreMean");
							console.log(tiredpreMean);
							let tirednextMean = parseInt(tirednextAll / tirednextLn)
							console.log("tirednextMean");
							console.log(tirednextMean);
							this.tiredpreMean = tiredpreMean
							this.tirednextMean = tirednextMean
							//训练前后对比
							let tireddifEnd = null
							if (tirednextMean >= tiredpreMean) {
								let dif = (tirednextMean / tiredpreMean - 1) * 100
								tireddifEnd = dif.toFixed(0)
							}
							if (tirednextMean < tiredpreMean) {
								let dif = (1 - tirednextMean / tiredpreMean) * 100
								tireddifEnd = dif.toFixed(0)
							}
							this.tiredcontrast = tireddifEnd


							//此时段疲劳均值    emotionData      
							let emotionhourAll = 0
							let emotionln = 0
							//训练前均值
							let emotionpreAll = 0
							let emotionpreLn = 0
							let emotionnextAll = 0
							let emotionnextLn = 0
							res.data.emotionData.forEach(item => {
								if(item){
									emotionhourAll += item.emotion_index
									emotionln += 1
									if (item.time_str < this.trainStart) {
										emotionpreAll += item.emotion_index;
										emotionpreLn += 1;
									}
									if (item.time_str >= this.trainEnd) {
										emotionnextAll += item.emotion_index;
										emotionnextLn += 1;
									}
								}
							})
							this.tiredhourMean = parseInt(emotionhourAll / emotionln)
							let emotionpreMean = parseInt(emotionpreAll / emotionpreLn)
							let emotionnextMean = parseInt(emotionnextAll / emotionnextLn)
							this.emotionpreMean = emotionpreMean
							this.emotionnextMean = emotionnextMean
							//训练前后对比
							let emotiondifEnd = null
							if (emotionnextMean >= emotionpreMean) {
								let dif = (emotionnextMean / emotionpreMean - 1) * 100
								emotiondifEnd = dif.toFixed(0)
							}
							if (emotionnextMean < emotionpreMean) {
								let dif = (1 - emotionnextMean / emotionpreMean) * 100
								emotiondifEnd = dif.toFixed(0)
							}
							this.emotioncontrast = emotiondifEnd

						}
						let initdata = []
						for (let i in this.Mdata) {
							if (res.data.stressData[i]) {
								let colorStr = '#55CF04'
								if (res.data.stressData[i].stress_index >= 50 && res.data.stressData[i]
									.stress_index < 70) {
									colorStr = '#01D6D6'
								}
								if (res.data.stressData[i].stress_index >= 70) {
									colorStr = '#FF0036'
								}
								initdata.push({
									value: res.data.stressData[i].stress_index,
									itemStyle: {
										color: colorStr
									}
								})
							} else {
								initdata.push(null)
							}
						}
						let ns = parseInt(new Date().getTime()/1000)
						if((ns-trainData.end_time)>1800){
							if(this.nextMeanChange==''||!this.nextMeanChange){
								this.undata = true;
							}
						}
						this.initLineChart(initdata)
						this.initBarChart(initdata)
						if (res.status == 400) {
							this.$toast('暂无数据');
						}
					})
				}
			})
		},
	};
</script>
<style lang='less' scoped>
	.box {
		padding: 0px 16px;
	}

	.header {
		height: 18px;
		padding-top: 20px;
		padding-bottom: 16px;
		display: flex;
		justify-content: space-between;
	}

	.header-text {
		height: 18px;
		line-height: 18px;
		font-size: 18px;
		font-weight: 500;
		color: #333;
	}

	.header-time {
		height: 148px;
		line-height: 14px;
		font-size: 14px;
		margin-top: 2px;
		color: #333;
	}

	.complete {
		height: 40px;
		padding: 16px 12px;
		background-color: #fff;
		border-radius: 10px;
		display: flex;
		justify-content: flex-start;
		margin-bottom: 10px;
	}

	.complete img {
		height: 40px;
	}

	.complete-info {
		height: 40px;
		margin-left: 10px;
	}

	.complete-title {
		height: 20px;
		line-height: 20px;
		font-size: 14px;
		font-weight: 700;
		color: #000;
	}

	.complete-num {
		height: 20px;
		line-height: 20px;
		font-size: 14px;
		color: #707070;
	}

	.complete-num span {
		font-weight: 700;
		color: #000;
	}

	.day-chart {
		position: relative;
	}

	.chart-content {
		padding: 12px;
		background-color: #fff;
		border-radius: 10px;
		margin-bottom: 10px;
		padding-bottom: 40px;
	}

	.empty img {
		display: block;
		width: 120px;
		height: 120px;
		margin: 20px auto;
	}

	.empty-text {
		height: 20px;
		line-height: 20px;
		font-size: 14px;
		text-align: center;
		color: #999;
		font-weight: 500;
	}

	.chart-main {
		display: flex;
		justify-content: center;
	}

	.text-tag {
		height: 200px;
	}

	.text-tag-aa {
		height: 40px;
		line-height: 20px;
		font-size: 12px;
		color: #FF0036;
		font-weight: 400;
		width: 24px;
		margin: 10px 0px;
	}

	.text-tag-bb {
		height: 40px;
		line-height: 20px;
		font-size: 12px;
		color: #01D6D6;
		font-weight: 400;
		width: 24px;
	}

	.text-tag-cc {
		height: 40px;
		line-height: 20px;
		font-size: 12px;
		color: #55CF04;
		font-weight: 400;
		width: 24px;
		margin: 30px 0px;
	}

	.text-tag-aaa {
		height: 40px;
		line-height: 20px;
		font-size: 12px;
		color: #FF0036;
		font-weight: 400;
		width: 24px;
		margin: 55px 0px 15px;
	}

	.text-tag-bbb {
		height: 40px;
		line-height: 20px;
		font-size: 12px;
		color: #01D6D6;
		font-weight: 400;
		width: 24px;
	}

	.text-tag-ccc {
		height: 40px;
		line-height: 20px;
		font-size: 12px;
		color: #55CF04;
		font-weight: 400;
		width: 24px;
		margin: 20px 0px 20px;
	}

	.chart-day {
		height: 200px;
		width: 248px;
		margin: 0px 5px;
		position: relative;
		background-color: #F5F8F8;
	}

	.chart-day-main {
		width: 240px;
		height: 200px;
		margin: 0 auto;
		position: relative;
	}

	.bar-box {
		padding-top: 2px;
		padding-left: 2px;
		padding-right: 2px;
		position: absolute;
		bottom: 0px;
		z-index: 11;
		border-top: 1px dashed #F5F8F8;
		border-left: 1px dashed #F5F8F8;
		border-right: 1px dashed #F5F8F8;
		border-radius: 3px 3px 0px 0px;
	}

	.bar-box-ac {
		padding-top: 2px;
		padding-left: 2px;
		padding-right: 2px;
		position: absolute;
		bottom: 0px;
		z-index: 11;
		border-top: 1px dashed #B5B5B5;
		border-left: 1px dashed #B5B5B5;
		border-right: 1px dashed #B5B5B5;
		border-radius: 3px 3px 0px 0px;
	}

	.train-point {
		width: 16px;
		height: 12px;
		line-height: 12px;
		font-size: 12px;
		color: #666666;
		position: absolute;
		top: -30px;
		left: 0px;
		word-spacing: 0px;
	}

	.bar {
		width: 10px;
		border-radius: 3px 3px 0px 0px;
	}

	.point-line-a {
		width: 100%;
		height: 1px;
		background-color: #E3E8E8;
		position: absolute;
		left: 0px;
		top: 60px;
	}

	.point-line-b {
		width: 100%;
		height: 1px;
		background-color: #E3E8E8;
		position: absolute;
		left: 0px;
		top: 100px;
	}

	.mean-line {
		width: 100%;
		height: 1px;
		border-bottom: 1px dashed #01D6D6;
		position: absolute;
		left: 0px;
		z-index: 8;
	}

	.mean-point {
		width: 40px;
		height: 20px;
		line-height: 20px;
		background: #01D6D6;
		border-radius: 3px;
		text-align: center;
		color: #fff;
		font-size: 12px;
		font-weight: 500;
		position: absolute;
		right: -47px;
		z-index: 8;
	}

	.line-d {
		height: 60px;
		width: 1px;
		position: absolute;
		top: 0px;
		left: 0px;
		background-color: #FF0036;
	}

	.line-e {
		height: 40px;
		width: 1px;
		position: absolute;
		top: 60px;
		left: 0px;
		background-color: #01D6D6;
	}

	.line-f {
		height: 100px;
		width: 1px;
		position: absolute;
		top: 100px;
		left: 0px;
		background-color: #55CF04;
	}

	.line-dd {
		height: 60px;
		width: 1px;
		position: absolute;
		top: 0px;
		right: 0px;
		background-color: #FF0036;
	}

	.line-ee {
		height: 40px;
		width: 1px;
		position: absolute;
		top: 60px;
		right: 0px;
		background-color: #01D6D6;
	}

	.line-ff {
		height: 100px;
		width: 1px;
		position: absolute;
		top: 100px;
		right: 0px;
		background-color: #55CF04;
	}

	.num-tag {
		height: 200px;
		position: relative;
		width: 20px;
	}

	.num-tag-a {
		height: 20px;
		line-height: 20px;
		font-size: 12px;
		color: #333333;
		font-weight: 400;
		position: absolute;
		left: 0px;
		top: 0px;
	}

	.num-tag-b {
		height: 20px;
		line-height: 20px;
		font-size: 12px;
		color: #333333;
		font-weight: 400;
		position: absolute;
		left: 0px;
		top: 50px;
	}

	.num-tag-c {
		height: 20px;
		line-height: 20px;
		font-size: 12px;
		color: #333333;
		font-weight: 400;
		position: absolute;
		left: 0px;
		top: 90px;
	}

	.num-tag-d {
		height: 20px;
		line-height: 20px;
		font-size: 12px;
		color: #333333;
		font-weight: 400;
		position: absolute;
		left: 0px;
		bottom: 0px;
	}

	.day-time-list {
		width: 240px;
		margin: 0 auto;
		height: 16px;
		display: flex;
		justify-content: space-between;
	}

	.day-time-item {
		height: 16px;
		line-height: 16px;
		font-size: 12px;
		color: #333333;
	}

	.low {
		height: 94px;
		line-height: 94px;
		font-size: 16px;
		font-weight: 600;
		color: #666;
		text-align: center;
	}

	.no-unscramble {
		height: 50px;
		line-height: 50px;
		text-align: center;
		color: #999;
		font-weight: bolder;
		font-size: 12px;
	}

	.time-list-box {
		position: absolute;
		left: 0px;
		bottom: -24px;
		width: 100%;
	}

	.minute-point {
		height: 16px;
		line-height: 16px;
		font-size: 12px;
		color: #333333;
		position: absolute;
		top: 0px;
		right: -16px;
	}

	.train-info {
		height: 94px;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.train-time {
		width: 49%;
		height: 62px;
		padding: 16px 0px;
		background-color: #fff;
		border-radius: 10px;
	}

	.train-title {
		height: 14px;
		line-height: 14px;
		color: #333;
		font-size: 14px;
		margin-bottom: 16px;
		text-align: center;
	}

	.train-time-num {
		height: 32px;
		display: flex;
		justify-content: center;
	}

	.time-min {
		height: 32px;
		line-height: 32px;
		font-size: 32px;
		font-weight: 900;
		color: #333;
		font-family: 'avenir';
		margin-right: 5px;
	}

	.min-text {
		height: 14px;
		line-height: 14px;
		font-size: 14px;
		color: #333;
		margin-top: 12px;
		font-weight: 500;
		margin-right: 5px;
	}

	.time-sec {
		height: 32px;
		line-height: 32px;
		font-size: 32px;
		font-weight: 900;
		color: #333;
		font-family: 'avenir';
		margin-right: 5px;
	}

	.sec-text {
		height: 14px;
		line-height: 14px;
		font-size: 14px;
		color: #333;
		margin-top: 12px;
		font-weight: 500;
	}

	.lower {
		width: 49%;
		height: 62px;
		padding: 16px 0px;
		background-color: #fff;
		border-radius: 10px;
	}

	.lower-title {
		height: 14px;
		line-height: 14px;
		text-align: center;
		font-size: 14px;
		color: #333;
		margin-bottom: 10px;
	}

	.lower-identifying {
		height: 16px;
		line-height: 16px;
		font-size: 16px;
		text-align: center;
		font-weight: 600;
		color: #04E1CD;
		margin-bottom: 10px;
	}

	.lower-point {
		height: 12px;
		line-height: 12px;
		font-size: 12px;
		color: #999999;
		text-align: center;
	}

	.contrast-stress {
		height: 62px;
		padding: 16px 0px;
		background-color: #fff;
		border-radius: 10px;
		display: flex;
		justify-content: space-between;
	}

	.train-pre {
		width: 49%;
	}

	.pre-title {
		height: 14px;
		line-height: 14px;
		font-size: 14px;
		text-align: center;
		color: #333;
		margin-bottom: 16px;
	}

	.pre-index {
		height: 32px;
		display: flex;
		justify-content: center;
	}

	.pre-num {
		height: 32px;
		line-height: 32px;
		font-size: 32px;
		font-weight: 900;
		color: #333;
		font-family: 'avenir';
		margin-right: 5px;
	}

	.pre-text {
		height: 14px;
		line-height: 14px;
		font-size: 14px;
		color: #333;
		margin-top: 12px;
		font-weight: 500;
	}

	.mid-icn {
		height: 40px;
		width: 1px;
		background-color: #EAEFEF;
		margin-top: 11px;
	}

	.train-next {
		width: 49%;
	}

	.contrast-index {
		height: 32px;
		display: flex;
		justify-content: center;
		margin-top: 16px;
	}

	.contrast-num {
		height: 32px;
		line-height: 32px;
		font-size: 32px;
		font-weight: 900;
		color: #333;
		font-family: 'avenir';
		margin-right: 5px;
	}

	.contrast-text {
		height: 14px;
		line-height: 14px;
		font-size: 14px;
		color: #333;
		margin-top: 12px;
		font-weight: 500;
	}

	.back {
		margin-top: 30px;
		height: 50px;
		line-height: 50px;
		border-radius: 25px;
		text-align: center;
		font-size: 16px;
		font-weight: 500;
		color: #01D6D6;
		background-color: #fff;
		border: 1px solid #01D6D6;
	}

	.chartLine {
		height: 200px;
	}

	.index-type {
		height: 28px;
		background-color: #f1f3f3;
		border-radius: 14px;
		display: flex;
		justify-content: center;
		width: 110px;
		position: relative;
		left: 95px;
		top: 10px;
		/* border: 1px solid #ccc; */
	}

	.choice-index {
		height: 28px;
		line-height: 28px;
		font-size: 14px;
		font-weight: 500;
		color: #333;
	}

	.index-more {
		display: block;
		height: 16px;
		width: 16px;
		margin-top: 6px;
		margin-left: 5px;
	}

	.index-list {
		width: 110px;
		position: absolute;
		top: 28px;
		left: 0px;
		z-index: 11;
	}

	.index-item {
		height: 28px;
		line-height: 28px;
		text-align: center;
		background-color: #01D6D6;
		font-size: 14px;
		font-weight: 500;
		color: #fff;
		border-radius: 14px;
		margin-bottom: 5px;
	}
</style>
